import {PointsAccrual} from "../types/Types";
import React from "react"
import LocationTag from "../tag/LocationTag";
import PointsTag from "../tag/PointsTag";
import TimeTag from "../tag/TimeTag";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faClock, faCoins, faStar} from "@fortawesome/free-solid-svg-icons";
import {Link} from "react-router-dom";
import DateTime from "../date/DateTime";
import {V2GlassChip, V2GlassSurface} from "./v2/V2Glass";

interface Props {
    pointsAccrual: PointsAccrual;
    v2?: boolean;
}

function PointsRow(props: Props) {
    const hasValidTime = typeof props.pointsAccrual.timeCheckedIn === "number"
        && Number.isFinite(props.pointsAccrual.timeCheckedIn)
        && props.pointsAccrual.timeCheckedIn !== 60;

    if (props.v2) {
        return (
            <V2GlassSurface className="user-v2-points-row v2-glass-list-row">
                <div className="user-v2-points-main">
                    <Link to={`/location/${props.pointsAccrual.locationId}/sessions`} className="user-v2-location-name-link">
                        <V2GlassChip className="v2-glass-location-chip">{props.pointsAccrual.locationName}</V2GlassChip>
                    </Link>
                    <V2GlassChip className="user-v2-points-chip">
                        <FontAwesomeIcon icon={faCoins} />
                        <span>{props.pointsAccrual.points}</span>
                    </V2GlassChip>
                    {(!props.pointsAccrual.isUnique && hasValidTime) && (
                        <V2GlassChip className="user-v2-points-time-chip">
                            <FontAwesomeIcon icon={faClock} />
                            <span>{props.pointsAccrual.timeCheckedIn}</span>
                        </V2GlassChip>
                    )}
                    {props.pointsAccrual.isBonus && (
                        <V2GlassChip className="user-v2-points-bonus-chip">
                            <FontAwesomeIcon icon={faStar} />
                        </V2GlassChip>
                    )}
                </div>
                <V2GlassChip className="user-v2-visit-date-chip">
                    <DateTime date={props.pointsAccrual.recordedAt}/>
                </V2GlassChip>
            </V2GlassSurface>
        );
    }

    return (
        <>
            <div className={`news-item`}>
                <div>
                    <div className={"d-inline-block mr-1"}>
                        <LocationTag
                            name={props.pointsAccrual.locationName}
                            id={props.pointsAccrual.locationId}
                            session={undefined}
                            displayVerificationTag={false}
                            linksToTab={"sessions"}
                        />
                    </div>
                    <div className={"d-inline-block mr-2"}><PointsTag points={props.pointsAccrual.points}/></div>
                    {(!props.pointsAccrual.isUnique && hasValidTime) && <div className={"d-inline-block"}><TimeTag minutes={props.pointsAccrual.timeCheckedIn!}/></div>}
                    {props.pointsAccrual.isBonus && <FontAwesomeIcon className="animated zoomIn icon-bonus" icon={faStar} />}
                </div>
                <div>
                    <div style={{float: "right"}}>
                        <small className={"ml-2 d-inline-block"}>
                            <div className={"d-inline-block"}>{props.pointsAccrual.recordedAt.toDateString()} at {props.pointsAccrual.recordedAt.toTimeString().substring(0, 5)}</div>
                        </small>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PointsRow;
